import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/main.scss'
import * as options from '@/config/options'

import VueAPI from '@/plugins/API/'

import vMediaQuery from 'v-media-query'
import VModal from 'vue-js-modal'
import svg4everybody from 'svg4everybody'

Vue.use(VueAPI, options.VUE_API)

Vue.use(vMediaQuery, options.VUE_MEDIAQUERY)
Vue.use(VModal)

Vue.config.productionTip = false

svg4everybody()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
